import React, { Suspense } from "react";

import { GameplayContainerWrapper } from "./elements";
import useController from "./useController";

const GameplayContainer = ({ children }) => {
	const {
		state: { bgImage, bgSize },
	} = useController();

	return (
		<Suspense fallback={<div>Loading...</div>}>
			<GameplayContainerWrapper
				bgImage={bgImage}
				bgSize={bgSize}>
				{children}
			</GameplayContainerWrapper>
		</Suspense>
	);
};

export default GameplayContainer;
